module.exports = __webpack_public_path__ + "media/images/svg/megaphone-081f70b5d904ae4d3ba1ba19faea3683.svg";